import React from 'react';

import {DropTitle, HiddenContainer, HiddenItem, HiddenItemWrapper} from './styles';

export default ({data, onClick, mHeigth = '400px'}: {data: Array<any>; mHeigth?: string; onClick: (...args: any[]) => void}) => {
  return (
    <HiddenContainer mHeigth={mHeigth}>
      {data.map((el, key) => (
        <HiddenItem key={key} onClick={() => onClick(el)}>
          <HiddenItemWrapper>
            <DropTitle>{`************${el?.last4}`}</DropTitle>
          </HiddenItemWrapper>
        </HiddenItem>
      ))}
    </HiddenContainer>
  );
};
